export const expandCollapse_filedMirgrants = (node) => {
  //   外边距  字段迁移
  if (node.data.design.expandCollapse_marginBottom) {
    node.data.design.self_marginBottom = node.data.design.expandCollapse_marginBottom
  }
  if (node.data.design.expandCollapse_marginLeft) {
    node.data.design.self_marginLeft = node.data.design.expandCollapse_marginLeft
  }
  if (node.data.design.expandCollapse_marginRight) {
    node.data.design.self_marginRight = node.data.design.expandCollapse_marginRight
  }
  if (node.data.design.expandCollapse_marginTop) {
    node.data.design.self_marginTop = node.data.design.expandCollapse_marginTop
  }
  if (node.data.design.expandCollapse_marginUnit) {
    node.data.design.self_marginUnit = node.data.design.expandCollapse_marginUnit
  }

  return node
}
